module.exports = __webpack_public_path__ + "8eefa32b25178723e46434631888164e.jpg";